/**
 * Montserrat font loader for jsPDF
 * Registers the font with jsPDF for proper Unicode support
 */

import { jsPDF } from 'jspdf';
import { MONTSERRAT_REGULAR, MONTSERRAT_BOLD } from './montserrat-base64';

/**
 * Registers Montserrat fonts with a jsPDF document instance
 * Must be called before using the font
 */
export function registerMontserratFonts(doc: jsPDF): void {
  // Add fonts to virtual file system
  doc.addFileToVFS('Montserrat-Regular.ttf', MONTSERRAT_REGULAR);
  doc.addFileToVFS('Montserrat-Bold.ttf', MONTSERRAT_BOLD);

  // Register fonts with jsPDF
  doc.addFont('Montserrat-Regular.ttf', 'Montserrat', 'normal');
  doc.addFont('Montserrat-Bold.ttf', 'Montserrat', 'bold');
}
